import { type VariantProps, cva } from 'class-variance-authority';
import { ReactNode } from 'react';

const inputLabel = cva('select-none text-label self-start', {
  variants: {
    required: {
      true: "after:content-['_*']",
    },
  },
});

type InputLabelProps = Omit<React.HTMLProps<HTMLLabelElement>, 'required'> &
  VariantProps<typeof inputLabel> & {
    children: ReactNode;
  };

export const InputLabel = ({
  children,
  required,
  ...props
}: InputLabelProps) => (
  <label {...props} className={inputLabel({ required })}>
    {children}
  </label>
);
